import { UserStore } from '../interfaces/UserStore';

export const INITIAL_VALUES: UserStore = {
  user_ad: '',   
  name: '',
  store_id: '',
}
